export default "__VITE_ASSET__1ce17802__"